<div class="notd-doc-uploader">
  <div>
    <h6 i18n="@@ID-DOC-001">Identity Document
    <fa-icon *ngIf="user?.identityDoc" [icon]="['fas', 'check-circle']"></fa-icon>
    </h6>
    <p i18n="@@ID-DOC-002">
      For individuals, a copy of a Passport or US Identity document, that matches the tax form.
      For business, a copy of your business registration information.
    </p>
    <div class="col-12 text-center doc-spin" *ngIf="saving">
      <fa-icon [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
    </div>
    <inline-msg [inlineMsg]="componentMessage"></inline-msg>
  </div>

  <div class="row uploader-save">
    <uploader-field
      class="modal-container" class="col-12 col-sm-12 col-md-9 col-lg-10"
      [postUrl]="identityDocUrl"
      [maxSize]="2097152"
      (uploaderEmitter)="uploaderIdentityEvent($event)"></uploader-field>
    <div class="col-12 col-sm-12 col-md-3 col-lg-2 text-right">
      <button type="button"
              class="btn notd-primary-btn col-12"
              (click)="saveIdentityDoc()"
              [disabled] ="error || saving || !canSave()" i18n="@@GLOBAL-SAVE">Save</button>
    </div>
  </div>
  <div class="file-info-message" *ngIf="user?.identityDoc">
    <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
    <span>Your Identity Document file is already uploaded. You can check it by <a (click)="getIdentityDoc()">clicking this link</a>.</span>
  </div>
</div>
